import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

import ChannelCard from 'components/ChannelCard';
import { XIconButton, PlusIconButton, EditIconButton } from 'components/Button';
import * as Icons from 'components/Svg';
import { Menu, MenuItem } from 'components/Menu';

export const Tag = React.forwardRef(({ onDelete, onAdd, onClick, onEdit, tagId, children, icon, preIcon, clickIcon, disabled, className, size, ...props }, ref) => {
  let onDeleteClick = e => { 
    e.stopPropagation(); 
    onDelete?.(tagId);
  }
  let onAddClick = e => {
    e.stopPropagation();  
    onAdd?.(tagId);
  }
  let onEditClick = e => {
    e.stopPropagation();  
    onEdit?.(tagId);
  }
  let onItemClick = e => {
    e.stopPropagation();  
    onClick?.(tagId);
  }
  return (
  <div className={cx('g-tag', className, size, { clickable: _.isFunction(onClick), disabled })} onClick={onItemClick} ref={ref} {...props}>
    { preIcon && 
    <div className="pre-tag-icon">{ preIcon }</div>}
    {children}
    {(onDelete || onAdd || onEdit || clickIcon) &&
    <div className="tag-action">
      {onDelete && <XIconButton size="s" onClick={onDeleteClick} color="transparent" />}
      {onAdd && <PlusIconButton size="s" onClick={onAddClick} color="transparent" />}
      {onEdit && <EditIconButton size="s" onClick={onEditClick} color="transparent" />}
      { clickIcon && <div className="click-action-icon">{clickIcon}</div> }
    </div>}
    { icon && 
    <div className="tag-icon">{ icon }</div>}
  </div>)
})
export default Tag;


export const ChannelTag = React.forwardRef(({ channel,...props}, ref) => (
  <Tag {...props} className="channel" ref={ref}>
    <ChannelCard channel={channel} size="s" />
  </Tag>));

export const SceneTag = ({ scene, ...props }) => (
  <Tag {...props} className="scene">
    <div className="slide-thume" style={backgroundImage(scene.url)} />
  </Tag>)

export const ChannelGroupTag = React.forwardRef(({ tag,...props}, ref) => (
  <Tag tagId={ tag?.tagId } className="channel-tag" ref={ref} preIcon={<Icons.TagIcon />} {...props}>
    {tag?.name}
  </Tag>));

export const AccountGroupTag = ({ onDelete, onEdit, tag, ...tagProps}) => {
  let onDeleteClick = () => onDelete?.(tag?.tagId);
  let onEditClick = () => onEdit?.(tag?.tagId);
  return (
    <Menu target={props => <ChannelGroupTag tag={tag} {...props} {...tagProps} clickIcon={<Icons.EditIcon size="s" />} />}>
      <MenuItem onClick={onEditClick}>Rename Tag</MenuItem>
      <MenuItem className="delete" onClick={onDeleteClick}>Delete</MenuItem>
    </Menu>)
}



export const TagList = ({ children, className, size = 'm', layout = 'row', ...props }) => {
  return (
    <div className={cx('g-tag-list', size, layout, className)} >
      {_.map(children, (element, idx) => element 
        ? React.cloneElement(element, {
            ...element.props,
            key: `${element.props.tagId}${idx}`,
            size,
          }, element.props.children)
        : null
      )}
    </div>)
}